export default __webpack_public_path__ + "static/media/vendor-collage.0a12d55b.jpg";